<template>
    <div class="teacher-detail-dialog">
        <aj-form-detail :dialogTitle="dialogTitle" :dialog-visible.sync="visible" :footer-buttons="finalFooterButtons"
            dialogWidth="900px" :custom-body-style="bodyStyle">
            <!-- 自定义内容区域 -->
            <template #detail-content>
            <div class="detail-content-wrapper" v-loading="loading">
                <!-- 空数据提示 -->
                <div v-if="!loading && !detailData.teacherId" class="empty-tip">
                    <i class="el-icon-warning"></i>
                    <span>暂无讲师信息</span>
                </div>
                <!-- 基本信息卡片 -->
                <div class="info-card">
                    <div class="card-header">
                        <i class="el-icon-user-solid header-icon"></i>
                        <span class="header-title">基本信息</span>
                    </div>
                    <div class="card-body">
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">讲师姓名</span>
                                <span class="info-value">{{ detailData.teacherName || '-' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">讲师编码</span>
                                <span class="info-value">{{ detailData.teacherNumber || '-' }}</span>
                            </div>
                        </div>
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">讲师类型</span>
                                <span class="info-value "> <el-tag >{{ typeMap[detailData.teacherType] || '-' }}</el-tag></span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">职位头衔</span>
                                <span class="info-value">{{ detailData.teacherPosition || '-' }}</span>
                            </div>
                        </div>
                        <div class="info-row">
                            <div class="info-item full">
                                <span class="info-label">身份证号</span>
                                <span class="info-value">{{ detailData.teacherIdcard || '-' }}</span>
                            </div>
                        </div>
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">讲师分类</span>
                                <span class="info-value">{{ detailData.atcNames || '-' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">讲师标签</span>
                                <span class="info-value">{{ detailData.atlNames || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 联系信息卡片 -->
                <div class="info-card">
                    <div class="card-header">
                        <i class="el-icon-phone header-icon"></i>
                        <span class="header-title">联系信息</span>
                    </div>
                    <div class="card-body">
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">联系电话</span>
                                <span class="info-value">{{ detailData.contactPhone || '-' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">联系邮箱</span>
                                <span class="info-value">{{ detailData.contactEmail || '-' }}</span>
                            </div>
                        </div>
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">联系微信</span>
                                <span class="info-value">{{ detailData.contactWechat || '-' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">讲师负责人</span>
                                <span class="info-value">{{ detailData.auName || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 价格信息卡片 -->
                <div class="info-card">
                    <div class="card-header">
                        <i class="el-icon-money header-icon"></i>
                        <span class="header-title">价格信息</span>
                    </div>
                    <div class="card-body">
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">讲师价格</span>
                                <span class="info-value price">{{ detailData.teacherPrice ? `¥${detailData.teacherPrice}` : '-' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">价格区间</span>
                                <span class="info-value">{{ detailData.teacherPriceRange || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 其他信息卡片 -->
                <div class="info-card">
                    <div class="card-header">
                        <i class="el-icon-info header-icon"></i>
                        <span class="header-title">其他信息</span>
                    </div>
                    <div class="card-body">
                        <div class="info-row">
                            <div class="info-item">
                                <span class="info-label">擅长课程</span>
                                <span class="info-value">{{ detailData.teacherCourseTalent || '-' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">常驻地</span>
                                <span class="info-value">{{ detailData.teacherAddress || '-' }}</span>
                            </div>
                        </div>
                        <div class="info-row">
                            <div class="info-item full">
                                <span class="info-label">创建时间</span>
                                <span class="info-value">{{ detailData.createtime || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 简介信息卡片 -->
                <div class="info-card">
                    <div class="card-header">
                        <i class="el-icon-document header-icon"></i>
                        <span class="header-title">简介信息</span>
                    </div>
                    <div class="card-body">
                        <div class="intro-section" v-if="detailData.teacherHeader">
                            <span class="info-label">讲师头像</span>
                            <el-image :src="detailData.teacherHeader" style="width: 80px; height: 80px; border-radius: 8px; margin-left: 12px;" fit="cover" />
                        </div>
                        <div class="intro-section" v-if="detailData.teacherIntroduction">
                            <span class="info-label">讲师简介</span>
                            <span class="intro-content">{{ detailData.teacherIntroduction }}</span>
                        </div>
                        <div class="intro-section" v-if="detailData.teacherIntroductionFileOne">
                            <span class="info-label">简介附件1</span>
                            <a :href="detailData.teacherIntroductionFileOne" target="_blank" class="file-link">
                                <i class="el-icon-paperclip"></i>
                                点击查看附件
                            </a>
                        </div>
                        <div class="intro-section" v-if="detailData.teacherIntroductionFileTwo">
                            <span class="info-label">简介附件2</span>
                            <a :href="detailData.teacherIntroductionFileTwo" target="_blank" class="file-link">
                                <i class="el-icon-paperclip"></i>
                                点击查看附件
                            </a>
                        </div>
                    </div>
                </div>

                <!-- 讲师协议卡片 -->
                <div class="info-card" v-if="detailData.ajTeacherAgreementList && detailData.ajTeacherAgreementList.length > 0">
                    <div class="card-header">
                        <i class="el-icon-document-checked header-icon"></i>
                        <span class="header-title">讲师协议</span>
                    </div>
                    <div class="list-body">
                        <div class="list-item" v-for="(item, index) in detailData.ajTeacherAgreementList" :key="index">
                            <div class="list-item-main">
                                <span class="item-icon el-icon-document"></span>
                                <span class="item-title">{{ item.ataTitle || '协议' + (index + 1) }}</span>
                            </div>
                            <div class="list-item-extra">
                                <template v-if="item.ataPath">
                                    <template v-for="(fileUrl, idx) in parseFilePaths(item.ataPath)">
                                        <a v-if="fileUrl" :key="idx" :href="fileUrl" target="_blank" class="item-link">
                                            <i class="el-icon-download"></i>下载协议{{ idx + 1 }}
                                        </a>
                                    </template>
                                </template>
                                <span class="item-date">{{ item.ataDate || '-' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 试讲视频卡片 -->
                <div class="info-card" v-if="detailData.ajTeacherCourseTrailList && detailData.ajTeacherCourseTrailList.length > 0">
                    <div class="card-header">
                        <i class="el-icon-video-camera header-icon"></i>
                        <span class="header-title">试讲视频</span>
                    </div>
                    <div class="list-body">
                        <div class="list-item" v-for="(item, index) in detailData.ajTeacherCourseTrailList" :key="index">
                            <div class="list-item-main">
                                <span class="item-icon el-icon-video-camera" style="background: linear-gradient(135deg, #f59e0b, #d97706);"></span>
                                <div class="item-info">
                                    <span class="item-title">{{ item.atctTitle || '视频' + (index + 1) }}</span>
                                    <span class="item-desc">{{ item.atctDate || '-' }} {{ item.atctDes ? '· ' + item.atctDes : '' }}</span>
                                </div>
                            </div>
                            <div class="list-item-extra">
                                <template v-if="item.atctPath">
                                    <template v-for="(videoUrl, idx) in parseFilePaths(item.atctPath)">
                                        <a v-if="videoUrl" :key="idx" :href="videoUrl" target="_blank" class="item-link item-link-primary">
                                            <i class="el-icon-video-play"></i>观看视频{{ idx + 1 }}
                                        </a>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 授课记录卡片 -->
                <div class="info-card" v-if="detailData.ajTeacherCourseHistoryList && detailData.ajTeacherCourseHistoryList.length > 0">
                    <div class="card-header">
                        <i class="el-icon-reading header-icon"></i>
                        <span class="header-title">授课记录</span>
                    </div>
                    <div class="list-body">
                        <div class="list-item" v-for="(item, index) in detailData.ajTeacherCourseHistoryList" :key="index">
                            <div class="list-item-main">
                                <span class="item-icon el-icon-reading" style="background: linear-gradient(135deg, #10b981, #059669);"></span>
                                <div class="item-info">
                                    <span class="item-title">{{ item.atchTitle || '授课主题' }}</span>
                                    <span class="item-desc">{{ item.atchDate || '-' }} · {{ item.atchUnit || '-' }}</span>
                                </div>
                            </div>
                            <div class="list-item-extra">
                                <el-tag type="success" size="small" effect="light">
                                    <i class="el-icon-star-on"></i> {{ item.atchStar || 0 }}分
                                </el-tag>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </template>
        </aj-form-detail>
    </div>
</template>

<script>
import ajFormDetail from '@/components/ajForm/ajFormDetail.vue';
import { getAjTeacherDetails } from '@/api/api';
import qs from 'qs';
export default {
    name: 'TeacherDetailDialog',
    components: {
        ajFormDetail
    },
    props: {
        teacherId: {
            type: [String, Number],
            default: null
        },
        dialogTitle: {
            type: String,
            default: '讲师详情'
        },
        dialogWidth: {
            type: [String, Number],
            default: '900px'
        },
        footerButtons: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            visible: false,
            detailData: {},
            loading: false,
            typeMap: { 1: '内部', 2: '外部', 3: '独家' }
        };
    },
    computed: {
        bodyStyle() {
            return {
                maxHeight: '70vh',
                overflowY: 'auto',
                padding: '0'
            };
        },
        finalFooterButtons() {
            if (this.footerButtons && this.footerButtons.length > 0) {
                return this.footerButtons;
            }
            const buttons = [
                { text: '关闭', plain: true }
            ];
            return buttons;
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.loadTeacherDetail();
            }
        }
    },
    methods: {
        /**
         * 解析文件地址数组，返回数组
         */
        parseFilePaths(pathStr) {
            if (!pathStr) return [];
            try {
                const parsed = JSON.parse(pathStr);
                return Array.isArray(parsed) ? parsed : [parsed];
            } catch (e) {
                return [];
            }
        },
        open() {
            this.visible = true;
        },
        close() {
            this.visible = false;
        },
        async loadTeacherDetail() {
            if (!this.teacherId) {
                console.warn('teacherId 为空');
                return;
            }
            this.loading = true;
            console.log('开始加载讲师详情, teacherId:', this.teacherId);
            try {
                const res = await getAjTeacherDetails({ teacherId: this.teacherId });
                console.log('讲师详情返回数据:', res);
                if (res && res.status == 200) {
                    this.detailData = res.data || {};
                    console.log('讲师详情数据:', this.detailData);
                } else {
                    this.$message.error(res?.msg || '获取讲师详情失败');
                }
            } catch (error) {
                console.error('获取讲师详情失败:', error);
                this.$message.error('获取讲师详情失败');
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>
.teacher-detail-dialog {
    --primary-color: #8b5cf6;
    --text-primary: #1e293b;
    --text-secondary: #64748b;
    --border-color: #f0f0f0;
    --bg-card: #ffffff;
}

.detail-content-wrapper {
    padding: 20px 24px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.info-card {
    background: var(--bg-card);
    border-radius: 16px;
    margin-bottom: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
}

.info-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.info-card:last-child {
    margin-bottom: 0;
}

.card-header {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-bottom: 1px solid var(--border-color);
}

.header-icon {
    font-size: 18px;
    color: var(--primary-color);
    margin-right: 10px;
}

.header-title {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.card-body {
    padding: 20px;
}

.info-row {
    display: flex;
    margin-bottom: 16px;
}

.info-row:last-child {
    margin-bottom: 0;
}

.info-row + .info-row {
    padding-top: 16px;
    border-top: 1px dashed var(--border-color);
}

.info-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
}

.info-item:last-child {
    margin-right: 0;
}

.info-item.full {
    flex: 1;
}

.info-label {
    font-size: 13px;
    color: var(--text-secondary);
    margin-bottom: 6px;
    font-weight: 500;
}

.info-value {
    font-size: 14px;
    color: var(--text-primary);
    font-weight: 500;
    line-height: 1.5;
    word-break: break-word;
}

.type-tag {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    color: #0369a1;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
}

.price {
    color: #059669;
    font-weight: 700;
    font-size: 16px;
}

.intro-section {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
}

.intro-section:last-child {
    margin-bottom: 0;
}

.intro-section .info-label {
    flex-shrink: 0;
    width: 80px;
}

.intro-content {
    flex: 1;
    font-size: 14px;
    color: var(--text-primary);
    line-height: 1.6;
    white-space: pre-wrap;
}

.file-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--primary-color);
    text-decoration: none;
    font-size: 14px;
    transition: all 0.3s ease;
}

.file-link:hover {
    color: #7c3aed;
    transform: translateX(4px);
}

/* 列表样式 */
.list-body {
    padding: 0 4px;
}

.list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    margin-bottom: 8px;
    background: #fafbfc;
    border-radius: 10px;
    transition: all 0.2s ease;
}

.list-item:last-child {
    margin-bottom: 0;
}

.list-item:hover {
    background: #f0f4f8;
    transform: translateX(4px);
}

.list-item-main {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
}

.item-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: linear-gradient(135deg, #6366f1, #4f46e5);
    color: #fff;
    font-size: 16px;
    margin-right: 12px;
    flex-shrink: 0;
}

.item-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.item-title {
    font-size: 14px;
    font-weight: 500;
    color: var(--text-primary);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.item-desc {
    font-size: 12px;
    color: var(--text-secondary);
    margin-top: 4px;
}

.list-item-extra {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.item-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    background: #f1f5f9;
    border-radius: 6px;
    font-size: 12px;
    color: var(--text-secondary);
    text-decoration: none;
    transition: all 0.2s ease;
}

.item-link:hover {
    background: #e2e8f0;
    color: var(--text-primary);
}

.item-link-primary {
    background: linear-gradient(135deg, #eff6ff, #dbeafe);
    color: #3b82f6;
}

.item-link-primary:hover {
    background: linear-gradient(135deg, #dbeafe, #bfdbfe);
}

.item-date {
    font-size: 13px;
    color: var(--text-secondary);
}

@media (max-width: 768px) {
    .detail-content-wrapper {
        padding: 16px;
    }

    .info-row {
        flex-direction: column;
        margin-bottom: 12px;
    }

    .info-item {
        margin-right: 0;
        margin-bottom: 12px;
    }

    .info-item:last-child {
        margin-bottom: 0;
    }

    .intro-section {
        flex-direction: column;
    }

    .intro-section .info-label {
        margin-bottom: 8px;
    }

    .card-body {
        padding: 16px;
    }

    .list-item {
        flex-direction: column;
        align-items: flex-start;
        padding: 12px;
    }

    .list-item-main {
        width: 100%;
        margin-bottom: 10px;
    }

    .list-item-extra {
        width: 100%;
        justify-content: flex-start;
    }
}

/* 空数据提示 */
.empty-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #94a3b8;
}

.empty-tip i {
    font-size: 48px;
    margin-bottom: 16px;
    color: #cbd5e1;
}

.empty-tip span {
    font-size: 14px;
}
</style>
